'use strict';

// export this package's api
module.exports = require('./Upload');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-upload/lib/index.js
 ** module id = 655
 ** module chunks = 0 1
 **/